/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("web/script/polyfills/fetch");
var classListPolyfill = require("web/script/polyfills/classList");

/**
 * A map of doubleclick event names, and their real names.
 * You can specify a type with a slash in the form of 'accountId/type/event'
 */
export default {
    ADD_TO_CART: "4837424/sitec0/addto0",
    ANON_SIGN_UP: "4837424/sitec0/joinl0",
    FULL_SIGN_UP: "4837424/sitec0/joinl00",
    LYST_IT: "4837424/sitec0/lysti0",
    OTHER: "4837424/sitec0/other0",
    PRODUCT: "4837424/sitec0/produ0",
    FEED_FILTERS: "4837424/sitec0/viewu0",

    AFFILIATE_LEAD: "4837424/affil0/affil0",
    AFFILIATE_IN_STOCK: "4837424/affil0/affil00",
    AFFILIATE_OUT_OF_STOCK: "4837424/affil0/affil000",

    ANALYTICS_SESSION_ID: "4837424/dcm/analy0",

    ICON_CART: "4837424/icons0/check0",
    ICON_ADDRESS: "4837424/icons0/check00",
    ICON_PAYMENT: "4837424/icons0/check000",
    ICON_REVIEW: "4837424/icons0/check001",
    ICON_COMPLETE: "4837424/icons00/check0",

    SESSION_PURCHASED: "4837424/cls/custo0",
    SESSION_REPEAT: "4837424/cls/custo00",
    SESSION_LOYAL: "4837424/cls/custo000"
};

